document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('product-form form')) return;
  const requiredDetails = form.querySelector('.vb-personalisation textarea[required]');
  if (requiredDetails && !requiredDetails.value.trim()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    requiredDetails.setCustomValidity('Please enter your personalisation details.');
    requiredDetails.reportValidity();
  }
}, true);

document.addEventListener('input', function (event) {
  if (event.target.matches('.vb-personalisation textarea[required]')) {
    event.target.setCustomValidity('');
  }
});
